
<template>
  <a-modal
      :footer="footer"
      :visible="visible"
      @cancel="$emit('cancel', $event)"
      dialogClass="transparent"
      wrapClassName="custom-modal"
      :dialogStyle="{
        padding:0,
        backgroundColor: 'transparent',
      }"
      :bodyStyle="{
        padding:0,
        marginTop: 30,
        backgroundColor: 'transparent',
      }"
      ref="modal"
      v-bind="$attrs"
  >
    <template #closeIcon></template>
    <dd-header-card :header="title">
      <slot name="content">
        <p>{{description}}</p>
      </slot>
      <div class="flex-row gap-md justify-content-end align-items-center">
       <slot name="buttons"></slot>
      </div>
    </dd-header-card>
  </a-modal>
</template>

<script>
export default {
  name: "DialogModal.vue",
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: false
    },
    footer: {
      default: null,
      required: false,
      type: Boolean,
    }
  },
  methods: {
    close() {
      this.$refs.modal.close();
    }
  },
  computed:{
    isVisible(){
      return this.visible;
    }
  },
  beforeDestroy() {
    const html = document.getElementsByTagName('html')[0];
    html.style.overflowY = 'scroll';
  },
  watch:{
      visible(newV){
          const html = document.getElementsByTagName('html')[0];
          newV ? html.style.overflowY = 'hidden' : html.style.overflowY = 'scroll';
      },
      value(newV){
          const html = document.getElementsByTagName('html')[0];
          newV ? html.style.overflowY = 'hidden' : html.style.overflowY = 'scroll';
      },
  }
};
</script>
<style lang="scss" scoped>
@import "~@/_default.scss";
.transparent {
  background-color: transparent;
}
</style>
<style lang="scss">
@import "~@/_default.scss";
.custom-modal {
  overflow-y: scroll;
  .ant-modal-content {
    background-color: transparent;
    border-radius: 0;
  }
}
</style>
